module.exports = __webpack_public_path__ + "img/emoji_103.995e43f2.png";